import { startTransition, useState } from 'react'

import { ContractCalendar } from '@/entities/contract'
import { today, oneYearLater } from '@/shared/lib'

import { useRoomSchedules } from '../api/get-room-schedules'

type Props = {
  roomId: number
  startDate?: Date
  onSelect: (date?: Date) => void
}

export const ScheduleCalendar = ({ roomId, startDate, onSelect }: Props) => {
  const [month, setMonth] = useState<Date>(startDate ?? today)

  const { blockedDates } = useRoomSchedules({
    roomId,
    year: month.getFullYear(),
    month: month.getMonth() + 1,
  })

  const handleMonthChange = (date: Date) => {
    // month가 변경되어 데이터 fetching이 발생할 때 fallback UI를 표시하지 않도록 startTransition 적용
    startTransition(() => {
      setMonth(date)
    })
  }

  return (
    <div className="w-100 border-r border-gray-100 p-6">
      <h3 className="typo-headline2 mb-6 font-semibold text-black">
        입주 날짜를 선택해 주세요
      </h3>
      <ContractCalendar
        mode="single"
        size="large"
        className="p-0 shadow-none"
        selected={startDate}
        onMonthChange={handleMonthChange}
        onSelect={onSelect}
        today={today}
        month={month}
        disabled={{
          before: today,
          after: oneYearLater,
        }}
        blocked={blockedDates}
        startMonth={today}
        endMonth={oneYearLater}
        required
      />
    </div>
  )
}
